import { render, staticRenderFns } from "./pcHomePage.vue?vue&type=template&id=2c47eddd&scoped=true"
import script from "./pcHomePage.vue?vue&type=script&lang=js"
export * from "./pcHomePage.vue?vue&type=script&lang=js"
import style0 from "./pcHomePage.vue?vue&type=style&index=0&id=2c47eddd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c47eddd",
  null
  
)

export default component.exports